import styles from "./payment-badges.module.css"
const badges = [
  { name: "Visa", src: "/payment-badges/visa.svg" },
  { name: "Mastercard", src: "/payment-badges/mastercard.svg" },
  { name: "Troy", src: "/payment-badges/troy.png" },
]
export default function PaymentBadges() {
  return <div className={styles.paymentBadges} aria-label="Kabul edilen kartlar" data-parity-exception="payment-marks">{badges.map((badge) => (
    <span key={badge.name} className={styles.paymentBadge} data-testid="payment-badge"><img src={badge.src} alt={badge.name} loading="lazy" /></span>
  ))}</div>
}
